import { render, staticRenderFns } from "./SASExplore.vue?vue&type=template&id=45a4523c&"
import script from "./SASExplore.vue?vue&type=script&lang=js&"
export * from "./SASExplore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports